import { OidcIdentityProvidersApi } from '../../../../api-client';
import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';
import { getApiConfiguration } from '../../../../common';

type UseEnableOidcProvider = (
  options?: Omit<
    UseMutationOptions<
      AxiosResponse<void>,
      ErrorResponse,
      { id: string }
      >,
    'mutationFn'
    >,
) => UseMutationResult<
  AxiosResponse<void>,
  ErrorResponse,
  { id: string }
>;

export const useEnableOidcProvider: UseEnableOidcProvider = (
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const oidcIdentityProvidersApi = new OidcIdentityProvidersApi(getApiConfiguration());
  return useMutation(
    ({ id }: { id: string }) =>
      oidcIdentityProvidersApi.enableOidcProvider(id, tenantId),
    options,
  );
}
